import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './seriennr.list-view.html',
  styleUrls: ['./seriennr.list-view.scss'],
})
export class SeriennrListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
